module.exports = __webpack_public_path__ + "img/5.bc587a35.jpg";